import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ShellComponent } from './shell.component';
import { HeaderComponent } from './header/header.component';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzLayoutModule } from 'ng-zorro-antd/layout';

import { ProfileMenuContainerComponent } from './header/containers/profile-menu-container/profile-menu-container.component';
import { CoreModule } from '../core/core.module';
import { FormsModule } from '@angular/forms';
import { SharedModule } from '@app/shared';
import { UserProfileMenuComponent } from '@app/ui-components/user-profile-menu/user-profile-menu.component';
import { PersonaModule } from '@app/persona/persona.module';
import { MenuComponent } from '@app/shell/menu/menu.component';
import { SidebarComponent } from '@app/shell/sidebar/sidebar.component';
import { BodyComponent } from '@app/shell/body/body.component';
import { FooterComponent } from '@app/shell/footer/footer.component';
import { NewsModule } from '@app/news/news.module';
import { RouterModule } from '@angular/router';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzAlertModule } from 'ng-zorro-antd/alert';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        RouterModule,
        FormsModule,
        SharedModule,
        NzLayoutModule,
        PersonaModule,
        NewsModule,
        NzDrawerModule,
        NzDropDownModule,
        NzAlertModule
    ],
    declarations: [
        ShellComponent,
        HeaderComponent,
        MenuComponent,
        BodyComponent,
        SidebarComponent,
        FooterComponent,
        UserProfileMenuComponent,
        ProfileMenuContainerComponent
    ],
    exports: [
        ShellComponent,
        HeaderComponent,
        MenuComponent,
        BodyComponent,
        SidebarComponent,
        FooterComponent,
        UserProfileMenuComponent,
        ProfileMenuContainerComponent
    ]
})
export class ShellModule {
}
